import { useEffect, useState } from 'react';
import { UserCircle } from '@phosphor-icons/react';

type Props = {
  src?: string | null;
  alt?: string;
  className?: string;
  emptyClassName?: string;
  iconSize?: number;
  imageClassName?: string;
  emptyLabel?: string;
};

export function PersonAvatar({
  src,
  alt = 'Persona',
  className,
  emptyClassName,
  iconSize = 24,
  imageClassName,
  emptyLabel = 'Sin foto',
}: Props) {
  const [failed, setFailed] = useState(false);
  const imageSrc = src?.trim();

  useEffect(() => {
    setFailed(false);
  }, [imageSrc]);

  if (imageSrc && !failed) {
    return (
      <img
        src={imageSrc}
        alt={alt}
        className={[className, imageClassName].filter(Boolean).join(' ')}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className={['person-avatar-empty', emptyClassName ?? className].filter(Boolean).join(' ')} aria-label={emptyLabel}>
      <UserCircle size={iconSize} weight="duotone" />
    </span>
  );
}
